import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Race2ResultBody from '../../../casinoComponents/refResultModal/Race2ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

// Reference labels: win 1..4 → Player A..D, 0 → "T"
const WIN_LABEL = { 1: 'A', 2: 'B', 3: 'C', 4: 'D', 0: 'T' };

/**
 * Race to 2nd "Last Result" items in the reference markup (rendered inside
 * CasinoLastResult's .casino-video-last-results): span.resultb per round.
 * Click → full-page .loader-overlay (in .page-content) while the round detail loads,
 * then the reference result modal (RefResultModal + Race2ResultBody).
 * `onTitle` receives the game name from the last-results feed (reference res1.cname).
 */
const ResultRace2 = ({ data = [], gameType = 'race2', onTitle }) => {
  const [showModal, setShowModal] = useState(false);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(gameType);
        if (response?.success && response?.data?.data?.res) {
          setLastResults(response.data.data.res);
          const cname = response?.data?.data?.res1?.cname;
          if (cname && onTitle) onTitle(cname);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };

    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [gameType, onTitle]);

  const handleResultClick = async (resultItem) => {
    const mid = resultItem?.mid;
    if (!mid) return;
    setDetailResult(null);
    setLoading(true);
    try {
      const response = await getDetailResults(gameType, mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) setDetailResult(t1);
    } catch (error) {
      console.error('Error fetching detail results:', error);
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  const allResults = lastResults.length > 0
    ? lastResults
    : data.map((res) => ({ win: res?.win ?? res, mid: res?.mid ?? null }));

  return (
    <>
      {allResults.map((resultItem, index) => (
        <span
          key={index}
          className="resultb"
          onClick={() => handleResultClick(resultItem)}
        >
          {WIN_LABEL[String(resultItem?.win ?? '')] ?? ''}
        </span>
      ))}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || 'Race to 2nd'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Race2ResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default ResultRace2;
